/**
 * @ngdoc service
 * @name checkins.factory:addRsvpsToPicklists
 * @description
 *
 */
angular
    .module('festzelt-os.guestlists')
    .factory('removeRsvpsFromPicklists', [
        'locale',
        'Alert',
        'SweetAlert',
        'SelectBox',
        'Picklists',
        '$http',
        removeRsvpsFromPicklists
    ]);

function removeRsvpsFromPicklists(locale, Alert, SweetAlert, SelectBox, Picklists, $http) {
    return {
        key: 'remove-rsvps-from-picklists',
        title: 'Remove from Picklist(s)',
        level: 'selected',
        action: addToPicklist
    };

    function addToPicklist(action, store) {
        return locale.ready(['picklists', 'sweetalerts'])
            .then(() => {
                SelectBox.multiple(Picklists, {
                    displayField: 'name_with_count'
                }).then(response => {
                    $http.delete('picklists/rsvps', {
                        data: {
                            picklists: {
                                count: response.data.length,
                                filters: [
                                    {
                                        field: 'id',
                                        operator: 'IN',
                                        value: response.data
                                    }
                                ]
                            },
                            rsvps: store.getters.selectedFilters
                        }
                    }).then(() => {
                        store.dispatch('getData');
                        Alert.success(locale.getString('sweetalerts.remove_successful'), locale.getString('picklists.rsvps_successfully_removed'));
                    }, err => Alert.handle(err))
                }, err => Alert.handle(err));
            });
    }

}

/**
 * @ngdoc service
 * @name festzelt-os.guestlists.factory:addToAddressbook
 * @description
 */

class addRsvpsToAddressbook {
    constructor(Alert, $http, SweetAlert, $translate) {
        this.key = 'add-to-addressbook';
        this.level = 'selected';
        this.icon = 'address-book';
        this.title = 'Add to address book';
        this.alert = Alert;
        this.api = $http;
        this.sweetAlert = SweetAlert;
        this.translate = $translate;
        this.accessor = (rsvp) => {
            return !rsvp.contact.data.addressbook;
        };
    }

    action(action, store) {
        const translatedValue = (path, params) => {
            return this.translate.instant(`guestlists.workflows.ask-to-add-to-addressbook.${path}`, params);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', {number_of_rsvps: store.getters.selectedCount}),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
            },
        ).then(() => {
            return this.api.put(`contacts`, {
                relationship: 'rsvp',
                items: store.getters.selectedFilters,
                fields: {
                    addressbook: true
                }
            }).then(response => {
                return this.alert.success('Success', 'The contacts have been added to the address book');
            }, err => this.alert.handle(err));
        }, err => this.alert.handle(err));
    }
}

angular
    .module('festzelt-os.guestlists')
    .factory('addToAddressbook', [
        'Alert',
        '$http',
        'SweetAlert',
        '$translate',
        (Alert, $http, SweetAlert, $translate) => new addRsvpsToAddressbook(Alert, $http, SweetAlert, $translate)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/remove-rsvps-from-picklists.js